import React from 'react';
import { NavLink } from 'react-router-dom';
import { Logo as LogoSVG } from '../../assets';
import Paths from '../../const/paths';
import style from './styles/index.module.scss';

interface ILogo {
  image?: string;
}

const Logo: React.FC<ILogo> = ({ image = LogoSVG }) => {
  return (
    <NavLink to={Paths.ROOT.path}>
      <div className={style['logo-wrapper']}>
        <img width='100%' height='100px' src={image} alt='logo' />
      </div>
    </NavLink>
  );
};

export default Logo;
